import { module } from "angular";
import dynamicNumber from "angular-dynamic-number";
import comments from "@gtmhub/comments/module";
import core from "@gtmhub/core/module";
import employeesCore from "@gtmhub/employees/employees-core.module";
import quantivePlusModule from "@gtmhub/goals/components/quantive-plus/quantive-plus.module";
import insightsCode from "@gtmhub/insights/insights-core.module";
import { KpiService } from "@gtmhub/kpis";
import links from "@gtmhub/links/links.module";
import { CascadingMetricFormHeaderComponent } from "@gtmhub/okrs/metrics/components/cascading-metric-form/cascading-metric-form-header/cascading-metric-form-header.component";
import hotkeys from "@gtmhub/shared/libs/angular-hotkeys/angular-hotkeys.module";
import chartist from "@gtmhub/shared/libs/chartist/chartist.module";
import teamsCore from "@gtmhub/teams/teams-core.module";
import { ConfidenceLevelSelectorComponent } from "@webapp/okrs/metrics/components/confidence-level-selector/confidence-level-selector.component";
import { MetricMilestoneComponent } from "@webapp/okrs/metrics/components/metric-milestone/metric-milestone.component";
import { MetricNumberInputFieldComponent } from "@webapp/okrs/metrics/components/metric-number-input-field/metric-number-input-field.component";
import { MetricsFacade } from "@webapp/okrs/metrics/services/metrics-facade.service";
import { QuantivePlusAnotherSuggestionService } from "@webapp/platform-intelligence/quantive-plus/services/quantive-plus-another-suggestion.service";
import { CascadingMetricContributorComponent } from "./components/cascading-metric-form/cascading-metric-contributor.component";
import { CascadingMetricFormComponent, CascadingMetricFormModal } from "./components/cascading-metric-form/cascading-metric-form.component";
import { CascadingMetricValuesAffixInputComponent } from "./components/cascading-metric-values-affix-input/cascading-metric-values-affix-input.component";
import { DisableMetricSyncComponent, DisableMetricSyncModal } from "./components/disable-metric-sync/disable-metric-sync.modal.component";
import { MetricSnapshotPreviewComponent } from "./components/metric-snapshot-preview/metric-snapshot-preview.component";
import { DynamicMetricCtrl } from "./controllers/dynamic-metric";
import { EditDynamicMetricCtrl } from "./controllers/edit-dynamic-metric";
import { MetricCtrl } from "./controllers/metric";
import { MetricFormCtrl } from "./controllers/metric-form";
import { UpdateMetricCtrl } from "./controllers/update-metric";
import { ConfidenceLevelTrendChart } from "./directives/confidence-level-trend-chart.directive";
import { SetConfidence } from "./directives/set-confidence.directive";
import { TrendChartAntiKr } from "./directives/trend-chart-anti-kr.directive";
import { TrendChart } from "./directives/trend-chart.directive";
import metricsCore from "./metrics-core.module";
import { MetricLinkService } from "./services/metric-link.service";

const mod = module("metrics", [core, metricsCore, insightsCode, dynamicNumber, links, chartist, quantivePlusModule, hotkeys, comments, employeesCore, teamsCore]);

mod.controller("MetricCtrl", MetricCtrl);
mod.controller("UpdateMetricCtrl", UpdateMetricCtrl);
mod.controller("MetricFormCtrl", MetricFormCtrl);
mod.controller("DynamicMetricCtrl", DynamicMetricCtrl);
mod.controller("EditDynamicMetricCtrl", EditDynamicMetricCtrl);

mod.component("disableMetricSync", DisableMetricSyncComponent);
mod.component("cascadingMetricForm", CascadingMetricFormComponent);
mod.component("cascadingMetricContributor", CascadingMetricContributorComponent);
mod.component("cascadingMetricFormHeader", CascadingMetricFormHeaderComponent);
mod.component("cascadingMetricValuesAffixInput", CascadingMetricValuesAffixInputComponent);
mod.component("metricSnapshotPreview", MetricSnapshotPreviewComponent);

mod.downgradeComponent("metricNumberInputField", { component: MetricNumberInputFieldComponent, propagateDigest: false });
mod.downgradeComponent("confidenceLevelSelector", { component: ConfidenceLevelSelectorComponent, propagateDigest: false });
mod.downgradeComponent("metricMilestone", { component: MetricMilestoneComponent, propagateDigest: false });
mod.directive("confidenceLevelTrendChart", ConfidenceLevelTrendChart.factory());
mod.directive("trendChartAntiKr", TrendChartAntiKr.factory());
mod.directive("trendChart", TrendChart.factory());
mod.directive("setConfidence", SetConfidence.factory());

mod.service("MetricLinkService", MetricLinkService);
mod.service("DisableMetricSyncModal", DisableMetricSyncModal);
mod.service("CascadingMetricFormModal", CascadingMetricFormModal);
mod.service("KpiService", KpiService);

mod.downgradeInjectable("QuantivePlusAnotherSuggestionService", QuantivePlusAnotherSuggestionService);
mod.downgradeInjectable("MetricsFacade", MetricsFacade);

export default mod.name;
